<div class="rewatch-page">
  <div *ngIf="loading" class="state-message">
    <mat-icon class="spin">autorenew</mat-icon>
    Loading your video...
  </div>

  <div *ngIf="!loading && forbidden" class="state-message">
    <mat-icon>lock</mat-icon>
    <h2>You don't have access to this recording</h2>
    <p>Only people who purchased a seat in this webinar (or the host) can watch this replay.</p>
  </div>

  <div *ngIf="!loading && notFound && !forbidden" class="state-message">
    <mat-icon>videocam_off</mat-icon>
    <h2>Recording not available</h2>
    <p>We couldn't find a video for this webinar.</p>
  </div>

  <div *ngIf="!loading && video" class="video-card">
    <h1 class="webinar-title">{{ video.webinarName }}</h1>
    <div class="video-stage">
      <video
        class="video-player"
        controls
        autoplay
        muted
        playsinline
        webkit-playsinline
        preload="metadata"
        [poster]="video.posterImageUrl || null">
        <source [src]="safeSrc" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</div>
